import React, { Suspense } from "react";
import i18n from "./i18nextInit.jsx";

import Spinner from "./components/spinner/spinner.component";
import ErrorBoundary from "./components/errorBoundary/errorBoundary.component";

function withRoot(Component) {
  // this HOC is wrapper to provide RTL support to our app
  function WithRoot(props) {
    // Set document direction for RTL support
    React.useEffect(() => {
      document.documentElement.dir = i18n.dir();
      document.documentElement.lang = i18n.language;
    }, []);
    
    return (
      <ErrorBoundary>
        <Suspense fallback={<Spinner />}>
          <Component {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  }

  return WithRoot;
}

export default withRoot; 